module.exports = __webpack_public_path__ + "55864dd21578d87136a7f8b693eb7cf7.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/guitar/4_D#2.mp3
// module id = 79
// module chunks = 0